export const EN = 'en'
export const ES = 'es'
export const PT = 'pt'
export const VI = 'vi'
export const IOS = 'iOS'
export const ANDROID = 'Android'



// WEBPACK FOOTER //
// ./src/constants.js